import React from 'react';
import API from 'shared/constants/api';
import Layout from 'desktop/components/Layout/Layout';
import DESCRIPTION from 'shared/constants/seoDescriptions';
import TITLE from 'shared/constants/seoTitles';
import META_HEADER from 'shared/constants/seoHeaders';
import queryString from 'query-string';
import { setSeoSearchUrl, setLocation, seoRequest } from 'shared/actions/globals';
import { targeting, replaceSpace, subjectiveText } from 'shared/modules';
import { clearSelected, setTransportResults } from 'shared/actions/searchForm';
import types from 'shared/constants/json/transportTypes.json';
import SECONDARY_LOCATIONS from 'shared/constants/json/secondaryLocations.json';
import REGIONS_CITIES from 'shared/constants/json/regions&cities.json';
import CITIES from 'shared/constants/json/cities.json';
import { toLocalized, removeLocaleFromHref } from 'shared/helpers/locale';
import Commercial from './Commercial';

const CURRENT_TRANSPORT_ID = 200;
async function action(data) {
  const { fetch, store, /* baseUrl, */ path, query, translate, params } = data;
  const { globals, searchForm } = store.getState();
  const { location, locale } = globals;
  const baseUrl = '/gruzovye/';
  const { locationSlug } = params;
  const url = removeLocaleFromHref(`${baseUrl}${path}`.replace('//', '/'));
  if (location && location.is_country) {
    store.dispatch(setLocation(null));
  }

  if (
    location &&
    !locationSlug &&
    [...CITIES, ...SECONDARY_LOCATIONS, ...REGIONS_CITIES].find(item => item.id === location.id)
  ) {
    return {
      redirect: toLocalized(`/gruzovye/${location.slug}/`.replace(/\/\//g, '/'), locale),
    };
  }

  if (searchForm.selected.transport && searchForm.selected.transport.id !== CURRENT_TRANSPORT_ID) {
    store.dispatch(clearSelected());
  }

  const routeLocation = locationSlug
    ? [...CITIES, ...SECONDARY_LOCATIONS, ...REGIONS_CITIES].find(
        item => item.slug === locationSlug,
      )
    : null;

  if (locationSlug && !routeLocation) {
    return null;
  }

  if (routeLocation && (!globals.location || globals.location.slug !== locationSlug)) {
    store.dispatch(setLocation(routeLocation));
  }
  const seoResponse = await store.dispatch(seoRequest('/gruzovye', query));

  const brands = await fetch(
    `${API.ADVERT.MAKES_COUNT}?${queryString.stringify({
      transport: CURRENT_TRANSPORT_ID,
      ...(routeLocation ? { location: routeLocation.id } : {}),
      ...(!routeLocation && location ? { location: location.id } : {}),
    })}`,
  ).then(r => r.json());
  const { selected } = store.getState().searchForm;
  const storeParams = Object.entries(selected)
    .map(([key, value]) => (value && value.id ? [key, value.id] : [key, value]))
    .filter(([, value]) => !!value && (typeof value === 'string' || typeof value === 'number'))
    .reduce((result, item) => ({ ...result, [item[0]]: item[1] }), {});
  const { kind, meta, ...seoQuery } = seoResponse;
  const titleLocation =
    routeLocation && routeLocation.where ? routeLocation.where[globals.locale] : undefined;
  const transportType = seoQuery.transport || types.find(item => item.slug === 'gruzovye');
  const q = { ...storeParams, ...query };
  const { make = {}, model = {} } = seoQuery;

  let { year } = seoQuery;
  if (!year && query.yearFrom === query.yearTo) year = query.yearFrom;

  const seoLocation = location || routeLocation;

  const commonArguments = subjectiveText({
    make: (make && make.title) || '',
    makeTranslit: make[`${locale}_title`] || make.title || '',
    model: model.title || '',
    modelTranslit: model[`${locale}_title`] || '',
    transportTitle: (transportType && transportType.title) || '',
    transportNextTitle: (transportType && transportType.title) || '',
    transportDescriptions: (transportType && transportType.title) || '',
    transportNextDescriptions: (transportType && transportType.title) || '',
    transportHeader: (transportType && transportType.title) || '',
    transportNextHeader: (transportType && transportType.title) || '',
    reductionTranslit: transportType.slug === 'avtobus' ? 'бус' : '',
    subsection: (seoQuery && seoQuery.part_type && seoQuery.part_type.title) || '',
    isNew: q.isNew,
    transportType: transportType.slug,
    allData: {
      url: '/commercial/',
      baseUrl,
      locale,
      translate,
    },
    yearTitle: year ? `${year} ${translate('года')} ` : '',
    yearDescriptions: year ? `${year} ${translate('г.')} ` : '',
    cityTitle: (seoLocation && seoLocation.title) || 'Украина',
    cityDescriptions: (seoLocation && seoLocation.title) || 'Украина',
    cityHeader: (seoLocation && seoLocation.title) || 'Украина',
  });
  const description = replaceSpace(DESCRIPTION.SEARCH.commercial(commonArguments, translate));
  const title = replaceSpace(TITLE.SEARCH.commercial(commonArguments, translate));
  const metaHeader = META_HEADER.SEARCH.commercial(commonArguments, translate);
  store.dispatch(setSeoSearchUrl({ ...seoResponse, url }));
  await store.dispatch(setTransportResults(CURRENT_TRANSPORT_ID));
  await targeting(data);
  return {
    chunks: ['commercial'],
    title,
    description,
    routeName: 'commercial',
    shouldSetNoIndex: false,
    shouldSetIndex: true,
    component: (
      <Layout withBranding>
        <Commercial
          title={metaHeader}
          titleLocation={titleLocation}
          brands={brands}
          routeLocation={routeLocation}
        />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/desktop/routes/commercial/index.js